import * as api from '../api/externalAccounts'
import { ExternalAccountInterface } from '../Interfaces/ExternalAccountInterface'
import { actionCreatorAsync, AsyncAction } from './index'

export function getExternalAccounts(
  existingAccounts?: ExternalAccountInterface[],
): AsyncAction<ExternalAccountInterface[]> {
  return actionCreatorAsync<ExternalAccountInterface[]>('GET_EXTERNAL_ACCOUNTS', async () => {
    return existingAccounts ? Promise.resolve(existingAccounts) : (await api.getExternalAccounts()) || []
  })
}
